export const SUPPORT_END_POINT = {
  TICKET: (page: string | number, perPage: string | number) => `/support/tickets?page=${page}&perPage=${perPage}`,
  TICKET_DETAILS: (id: string | number) => `/support/tickets/${id}/details`,
  TICKET_DETAILS_MESSAGE: (id: string) => `/support/tickets/${id}/chat-messages`,
  TICKET_CREATE: '/support/tickets'
}

export const USER_END_POINT = {
  USER: 'users/profile',
  FORGOT_PASSWORD: 'users/forgot-password',
  RESET_PASSWORD: 'users/reset-password',
  CHANGE_PASSWORD: 'users/change-password',
  CHANGE_EMAIL: 'users/change-email',
  STRIPE_PRICES: 'stripe/prices',
  STRIPE_PRODUCTS: 'stripe/products',
  STRIPE_SUBSCRIPTION: 'stripe/subscriptions',
  STRIPE_INVOICES_LAST_URL: 'stripe/invoices/last-url',
  CONFIRM_EMAIL: (token: string) => `users/confirm-change-email/${token}`,
  IHF_LOGIN: 'users/get-ihf-login'
}

export const USERS_END_POINT = {
  USERS: 'users',
  USER_DETAILS: (id: string | number) => `users/${id}`
}

export const PAYMENT_END_POINT = {
  SETUP_INTENT: '/users/setup-intent',
  PAYMENT_METHOD: '/users/payment-method'
}

export const IHF_END_POINT = {
  LISTINGS: 'ihf/listings',
  LEADS: 'ihf/leads',
  ACTIVITY: 'ihf/activity'
}

export const STATISTICS = {
  ANALYTICS: 'analytics/multisite'
}

export const AUTH_END_POINT = {
  CSRF: 'csrf-cookie',
  LOGIN: 'auth/login',
  LOGOUT: 'auth/logout',
  MULTISITE_SPA: 'auth/multisite',
  MULTISITE_PROFILE: 'auth/multisite/profile',
  AUTH_TOKEN: 'auth/token',
  MULTISITE_IHF_LOGIN: 'auth/multisite/get-ihf-login',
  STUDIO_TOKEN: 'auth/studio-token',
  MULTISITE_STUDIO_TOKEN: 'auth/multisite/studio-token'
}
